export const jlptLevels = [
  { code: 'N5', name: 'Sơ cấp',       pillLabel: 'N5 – Sơ cấp' },
  { code: 'N4', name: 'Sơ trung cấp', pillLabel: 'N4 – Sơ trung cấp' },
  { code: 'N3', name: 'Trung cấp',    pillLabel: 'N3 – Trung cấp' },
];
